module.exports = __webpack_public_path__ + "static/media/agentNotifiedMobile.5008e8a5.png";